const YouTubeIcon = ({
  size = 36,
  className = '',
  onClick = (event) => {}
}: {
  size?: number;
  className?: string;
  onClick?: (event) => void;
}) => {
  return (
    <span className={'flex items-center ' + className} onClick={onClick}>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width={size}
        height={(size * 19) / 18}
        viewBox='0 0 18 19'
        fill='currentColor'
      >
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M9 3.33398C7.42412 3.33398 5.35786 3.40425 3.60702 3.54412C1.54076 3.71977 0.455268 4.06978 0.174953 6.13663C0.0702414 7.08255 0 8.37848 0 9.70953C0 11.0406 0.069591 12.3717 0.174953 13.2824C0.455268 15.3844 1.54076 15.7 3.60702 15.875C5.35786 16.05 7.42412 16.0851 9 16.0851C10.5759 16.0851 12.607 16.05 14.393 15.875C16.4592 15.6993 17.5096 15.3844 17.7899 13.2824C17.9298 12.3717 18 11.0406 18 9.70953C18 8.37848 17.9298 7.08255 17.7899 6.13663C17.5096 4.06978 16.4592 3.71912 14.393 3.54412C12.607 3.40425 10.5759 3.33398 9 3.33398ZM11.8724 9.70945L7.1792 7.01221V12.4418L11.8724 9.70945Z'
        />
      </svg>
    </span>
  );
};

export default YouTubeIcon;
